import { TicketReportPreviewDto } from './../../../../service/dto';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { TicketReportColumnDto, TicketReportColumnTemplateDto, TicketReportColumnValueTypeModeEnum, TicketReportDto, TicketReportPreviewRowDto, WorkflowDto } from '../../../../service/dto';
import { HttpWorkflowService } from '../../../../service/http-workflow.service';
import { HttpTicketReportService } from '../../../../service/http-ticket-report.service';
import { NzCustomColumn } from 'ng-zorro-antd/table';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TicketReportFormSimpleModalComponent } from '../ticket-report-form-simple-modal/ticket-report-form-simple-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TicketReportFormSubColumnModalComponent } from '../ticket-report-form-sub-column-modal/ticket-report-form-sub-column-modal.component';
import {
	faHome,
	faTicket,
	IconDefinition,
	faUser,
	faUsers,
	faLayerGroup,
	faIcons,
	faBuilding,
	faAnglesRight,
	faKeyboard,
	faComputerMouse,
	faMessage,
	faComment,
	faDashboard,
	faMicrochip,
	faDotCircle,
} from '@fortawesome/free-solid-svg-icons';
import { TicketReportDto, WorkflowDto } from '../../../../service/dto';
import {
	MonacoEditorModule,
	NGX_MONACO_EDITOR_CONFIG,
} from 'ngx-monaco-editor-v2';
import type * as monaco from 'monaco-editor';
import { NzMessageService } from 'ng-zorro-antd/message';

// export interface MenuGroup {
// 	label: string;
// 	templates: TicketReportColumnTemplateDto[];
// 	subMenus: MenuSubGroup[];
// }
// interface MenuSubGroup {
// 	label: string;
// 	payload: TicketReportColumnTemplateDto[];
// }

@Component({
	selector: 'app-ticket-report-form',
	standalone: false,
	templateUrl: './ticket-report-form.component.html',
	styleUrl: './ticket-report-form.component.scss',
})
export class TicketReportFormComponent implements OnInit {
	static counter = 0;

	form!: FormGroup;
	workflow?: WorkflowDto;
	ticketReport!: TicketReportDto;
	// menu: MenuGroup[] = [];
	previewData?: TicketReportPreviewDto;
	loading = false;

	editorOptions = {
		theme: 'vs-dark',
		language: 'sql',
		minimap: { enabled: false },
		automaticLayout: true,
		scrollBeyondLastLine: false,
		lineNumbers: 'on',
		tabSize: 4,
		wordWrap: 'on',
	};
	constructor(
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private modalService: NzModalService,
		private messageService: NzMessageService,
		private httpWorkflowService: HttpWorkflowService,
		private httpTicketReportService: HttpTicketReportService,
	) {}

	ngOnInit(): void {
		const workflowId = this.route.snapshot.paramMap.get('workflowId');
		const reportId = this.route.snapshot.paramMap.get('reportId');

		if (workflowId) {
			this.httpWorkflowService.get(+workflowId).subscribe((result) => {
				this.init({
					id: TicketReportFormComponent.getNextId(),
					createdAt: new Date(),
					name: '',
					description: '',
					sqlQuery:
						'SELECT *\nFROM ticket_snapshot\nWHERE\n\tworkflow_id = {{WORKFLOW}}\nAND created_at <= {{DATE_FILTER}}',
					isSummary: false,
					workflow: result,
					hashCode: 0,
				});
			});
		} else if (reportId) {
			this.httpTicketReportService
				.get(+reportId!)
				.subscribe((result) => this.init(result));
		}
	}
	init(input: TicketReportDto) {
		this.workflow = input.workflow;
		this.ticketReport = input;
		this.form = this.fb.group({
			name: [input.name, [Validators.required]],
			description: [input.description, [Validators.required]],
			sqlQuery: [input.sqlQuery, [Validators.required]],
			date: [
				new Date(),
				(control: any) => {
					const val = control.value;
					if (!val) return { required: true };
					if (val instanceof Date) {
						return isNaN(val.getTime())
							? { invalidDate: true }
							: null;
					}
					const parsed = new Date(val);
					return isNaN(parsed.getTime())
						? { invalidDate: true }
						: null;
				},
			],
		});
	}

	public static getNextId(): number {
		return --this.counter;
	}

	onCreate(): void {
		this.ticketReport.name = this.form.get('name')!.value;
		this.ticketReport.description = this.form.get('description')!.value;
		this.httpTicketReportService
			.create(this.workflow!.id, this.ticketReport)
			.subscribe((result) => {
				this.init(result);
			});
	}
	onSave(): void {
		this.ticketReport.name = this.form.get('name')!.value;
		this.ticketReport.description = this.form.get('description')!.value;
		this.ticketReport.sqlQuery = this.form.get('sqlQuery')!.value;
		this.httpTicketReportService
			.save(this.ticketReport.id, this.ticketReport)
			.subscribe((result) => {
				this.init(result);
			});
	}
	fetchPreview() {
		this.loading = true;
		const date = this.form.get('date')!.value;
		const payload = {
			sqlQuery: this.form.get('sqlQuery')!.value,
		} as any as TicketReportDto;

		this.httpTicketReportService
			.preview(this.workflow!.id, date, payload)
			.subscribe({
				next: (result) => {
					this.previewData = result;
					this.messageService.success('Preview loaded');
					this.loading = false;
				},
				error: (err) => {
					this.loading = false;
					this.modalService.error({
						nzTitle: 'Preview failed',
						nzContent: err?.message ?? 'Unable to fetch preview',
					});
				},
			});
		// this.httpTicketReportService.preview(this.workflow!.id, this.form.get('date')!.value, { sqlQuery: this.form.get('sqlQuery')!.value } as any as TicketReportDto).subscribe(result => {
		// 	this.previewData = result;
		// });
	}
	doDownload() {
		this.loading = true;
		const date = this.form.get('date')!.value;
		const payload = {
			sqlQuery: this.form.get('sqlQuery')!.value,
		} as any as TicketReportDto;

		this.httpTicketReportService
			.download(this.workflow!.id, date, payload)
			.subscribe({
				next: (result) => {
					this.messageService.success('Report generated');
					this.loading = false;
				},
				error: (err) => {
					this.loading = false;
					this.modalService.error({
						nzTitle: 'Report generation failed',
						nzContent: err?.message ?? 'Unable to generate report',
					});
				},
			});
	}
}
